import { roleStringList, roleToString, stringToRole, UserRole } from "utils/role";
import { HeaderWrapper, InviteHeader, PermissionHeader, ProfileHeader } from "./index.styles";
import UI from "@mile-meeting/mile-ui";

const TableHeader = ({
  selectedRole,
  onChangeRole,
}: {
  selectedRole?: UserRole;
  onChangeRole?: (value: UserRole) => void;
}) => {
  return (
    <HeaderWrapper>
      <ProfileHeader>
        <UI.Typography
          style={{ minWidth: "200px", maxWidth: "240px" }}
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
        >
          이메일
        </UI.Typography>
        <UI.SelectBox
          key={selectedRole}
          selectedData={selectedRole === undefined ? [""] : [roleToString(selectedRole)]}
          onChange={(value: string[]) => onChangeRole?.(stringToRole(value[0]))}
          data={roleStringList}
          renderSelectBox={() => (
            <PermissionHeader>
              <UI.Typography type="label01" fontStyle="medium" color="var(--alias-color-label-normal)">
                권한
              </UI.Typography>
              <UI.Icon name="chevronDown" size={16} color="var(--alias-color-label-normal)" />
            </PermissionHeader>
          )}
        />
      </ProfileHeader>
      <InviteHeader>
        <UI.Typography
          style={{ minWidth: "120px", maxWidth: "160px" }}
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
        >
          초대 현황
        </UI.Typography>
        <UI.Typography
          style={{ minWidth: "120px", maxWidth: "160px" }}
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
        >
          초대 재전송
        </UI.Typography>
        <UI.Typography
          style={{ minWidth: "120px", maxWidth: "160px" }}
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
        >
          초대 취소
        </UI.Typography>
      </InviteHeader>
    </HeaderWrapper>
  );
};

export default TableHeader;
